import { GPS_TYPE_TO_LABEL } from "@/utils/constants/gps";
import { Typography } from "@mui/material";
import { FC } from "react";

interface GpsTypeColumnProps {
  gpsType?: string | null;
}

const GpsTypeColumn: FC<GpsTypeColumnProps> = ({ gpsType }) => {
  if (!gpsType) {
    return <Typography>-</Typography>;
  }

  return <Typography>{GPS_TYPE_TO_LABEL[gpsType as GPSType]}</Typography>;
};

export default GpsTypeColumn;
